<template>
    <div class="container-center">
        <div class="cdetail">
            <h1>{{ detail.title }}</h1>
            <div>{{ detail.content }}</div>
        </div>

    </div><!-- container-center -->

</template>

<script type="text/babel">
    import banner from '@/assets/imgs/banner_invite.png'
export default {
    name: 'carouse-detail',
    data () {
        return {
            // 参数信息
            fid: this.$route.params.fid,
            detail:{
                "title":"大华集团",
                "content":"大华集团坚持以地产开发改善居民生活环境，提升区域价值，推动城市功能升级。在成批旧改、新农村建设上配合政府\n" +
                "\n" +
                "进行道路、管网等大市政基础设施建设；在开发区域内建设幼托、中小学、医院、社区公园等大公建配套；开发区域内整体规\n" +
                "\n" +
                "划和建设酒店、办公、购物中心等区域配套商业，“嘉年华”系列社区商业和时尚购物中心、城市精品酒店等持有运营的商业面\n" +
                "\n" +
                "积已逾80万㎡\n"
            }
        }
    },
    methods: {
    },
    created(){
        this.$root.navs = [{name:'集团简介详情',path:'/carouse'}];
        this.$root.headImage.src = banner;
    },
    mounted: function() {
        // this.$http.get('rest/api/invite/project/info', {
        //     params: {
        //         fid: this.fid,
        //     }
        // }).then((res) => {
        //     if (res.data.result) {
        //         this.infoData = res.data.value;
        //     }
        // })
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';
    .cdetail {
        padding: 50px 0;
        font-size: 14px;
    }
    .cdetail h1 {
        margin: 0 0 24px 0;
        color: #000;
        font-size: 18px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/carouse/CarouseDetail.vue